"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveActivityReportScope = void 0;
const types_1 = require("../../types");
const tools_1 = require("../../tools");
const resolveScope_1 = require("../utils/resolveScope");
const sqlDynamicSchemaTools_1 = require("../utils/sqlDynamicSchemaTools");
const utils_1 = require("../utils/utils");
/**
 * These 2 helpers are here to mitigate issues due to the differences between regular report and "Augmented" report formats
 *
 * Example:
 * - Regular format for MC/MCOL: { mcol: ["opt1", "opt3"] }
 * - Augmented format for MC/MCOL: { mcol: [{ key: "opt1", value: "Option 1", { key: "opt3", value: "Option 3" }] }
 */
const resolveActivityReportScope = (metaExpression, options) => {
    const { activity_report, activity, get_options_label, scolParams, mxolParams, } = options;
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.ACTIVITY_REPORT)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    if (!activity || !activity_report)
        return (0, utils_1.getMeResultNoResult)();
    const schema = (0, sqlDynamicSchemaTools_1.extractActivityOrListSchema)(activity, true);
    return (0, resolveScope_1.resolveScopeWithSchema)(metaExpression, {
        object: activity_report,
        schema,
        get_options_label,
        scolParams,
        mxolParams,
    });
};
exports.resolveActivityReportScope = resolveActivityReportScope;
